module.exports = __webpack_public_path__ + "static/media/hero.e3cd4d3f.jpg";